// Shared constants. The pricing constants mirror the BFF
// (bff/_shared/pricing.ts). They are used only for the client-side preview; the
// server recomputes the authoritative total from local catalog identifiers.

export const GOLD_BUY_RATE_USD_PER_M = 0.3;
export const GOLD_SELL_RATE_USD_PER_M = 0.2;
export const GOLD_BUY_MIN_M = 10;
export const GOLD_SELL_MIN_M = 50;
export const GOLD_MAX_M = 1_000_000;

/** No single line item may exceed this (matches fs_services_price_ceiling()). */
export const PRICE_CEILING_USD = 100_000;

export const BRAND = {
  name: 'Firstseller',
  tagline: 'The #1 destination for all your Old School Runescape needs.',
  disclaimer: 'Firstseller is not affiliated with Jagex Ltd.',
  founded: 2017,
} as const;

export const SOCIAL = {
  discord: 'https://discord.gg/firstseller',
  twitter: 'https://x.com/Firstseller07',
  instagram: 'https://instagram.com/firstseller.shop',
  tiktok: 'https://www.tiktok.com/@www.firstseller.shop',
} as const;

/** Public runtime config sourced from import.meta.env (browser-safe values only). */
export const ENV = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? '',
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY ?? '',
  bffUrl: (import.meta.env.VITE_BFF_URL ?? '').replace(/\/$/, ''),
  siteUrl: (import.meta.env.VITE_SITE_URL ?? 'http://localhost:5173').replace(/\/$/, ''),
} as const;

export const isSupabaseConfigured = Boolean(ENV.supabaseUrl && ENV.supabaseAnonKey);
export const isBffConfigured = Boolean(ENV.bffUrl);
